<template>
  <div class="feed-drawer__content" v-loading="loading">
    <p class="feed-drawer__title">
      {{$t('feed.create.title[0]')}}
      <span class="feed-drawer__title-sub">
        {{$t('feed.create.title[1]')}}
        <span>
          {{userName}}
        </span>
      </span>
    </p>

    <el-divider></el-divider>

    <el-form :model="createFeedForm" :rules="rules" ref="createFeedForm" label-position="top" label-width="120px" class="demo-ruleForm">
      <el-form-item :label="$t('feed.create.form.threadtype')" prop="threadtype">
        <el-select v-model="createFeedForm.threadtype" placeholder="Тип ленты">
          <el-option :label="type.title" :value="type.name" v-for="type in types" :key="type.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('feed.create.form.threadname')" prop="threadname">
        <el-input v-model="createFeedForm.threadname"></el-input>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item>
        <el-button type="primary" @click="submitForm('createFeedForm')">{{$t('feed.create.form.createButton')}}</el-button>
        <el-button @click="resetForm('createFeedForm')">{{$t('feed.create.form.cancelButton')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  /*
    adding a feeds appears on the panel, the template is taken from the settings config ../config/header
  */

  // vuex
  import { mapGetters } from 'vuex';

  // components
  import notify from "../../helpers/notify";

  // store
  import { ADD_FEED } from "../../store/actions/feeds";

  // bus
  import { drawerBus } from '../../bus/drawer';

  export default {
    name: "CreateFeed",
    data() {
      return {
        loading: false,
        createFeedForm: {
          threadtype: this.$t('feed.create.types[1].name'),
          threadname: ''
        },
        types: this.$t('feed.create.types'),
        rules: this.$t('feed.create.rules')
      };
    },
    computed: {
      ...mapGetters([
        'userName',
        'userId',
      ]),
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;

            let params = {
              uid: this.userId,
              ...this.createFeedForm
            };

            this.$store.dispatch(ADD_FEED, params).then((resp) => {
              notify.call(this, `${this.$t('feed.create.notify.create[0]')} ${this.createFeedForm.threadname} ${this.$t('feed.create.notify.create[1]')} ${this.userName} ${this.$t('feed.create.notify.create[2]')}`, "success");
              this.resetForm(formName);
              this.$router.push({
                name: 'feedSettings',
                params: {
                  threadId: resp.data.id
                }
              });

              this.loading = false;
              drawerBus.$emit('toggleDrawer');
            }).catch(() => {
              notify.call(this, `Превышен лимит на создание лент`, "error");
              this.loading = false;
            });
          } else {
            notify.call(this, this.$t('feed.create.notify.error'), "error");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
  };
</script>

<style>
  .feed-drawer__content {
    margin: 0 15px 0 15px;
  }
  .feed-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
  .feed-drawer__title-sub {
    display: block;
    padding-top: 10px;
    font-size: 14px;
    font-weight: 300;
    color: #303133;
  }
  .feed-drawer__title-sub span {
    color: #409EFF;
    font-weight: 500;
  }
</style>
